
export default {
  name: 'EmptyPageLayout',
};
